/** Default ticket list filters (manager). */
export const DEFAULT_TICKET_FILTERS = {
  customer: "all",
  technician: "all",
  status: "all",
};

/** API complaintStatus values for status filter. */
export const TICKET_STATUS_FILTER_OPTIONS = [
  { value: "Under_Review", label: "Under Review" },
  { value: "On_Hold", label: "On Hold" },
  { value: "Assigned", label: "Assigned" },
  { value: "Accepted", label: "Accepted" },
  { value: "Scheduled", label: "Scheduled" },
  { value: "In_Progress", label: "In Progress" },
  { value: "Quotation_Submitted", label: "Quotation Submitted" },
  { value: "Quotation_Accepted", label: "Quotation Accepted" },
  { value: "Closure_Requested", label: "Closure Requested" },
  { value: "Closure_Verified", label: "Closure Verified" },
  { value: "Closed", label: "Closed" },
  { value: "Rejected", label: "Rejected" },
];

export function cloneTicketFilters(filters) {
  return {
    customer: filters?.customer ?? "all",
    technician: filters?.technician ?? "all",
    status: filters?.status ?? "all",
  };
}

export function getDefaultTicketFilters() {
  return cloneTicketFilters(DEFAULT_TICKET_FILTERS);
}

export function areTicketFiltersEqual(a, b) {
  return (
    (a?.customer ?? "all") === (b?.customer ?? "all") &&
    (a?.technician ?? "all") === (b?.technician ?? "all") &&
    (a?.status ?? "all") === (b?.status ?? "all")
  );
}

export function countActiveTicketFilters(filters = DEFAULT_TICKET_FILTERS) {
  let count = 0;
  if (filters.customer && filters.customer !== "all") count += 1;
  if (filters.technician && filters.technician !== "all") count += 1;
  if (filters.status && filters.status !== "all") count += 1;
  return count;
}

export function resolveTicketListFilter(filters = DEFAULT_TICKET_FILTERS) {
  if (filters.status && filters.status !== "all") {
    return { type: "status", value: filters.status };
  }
  if (filters.technician && filters.technician !== "all") {
    return { type: "technician", value: filters.technician };
  }
  if (filters.customer && filters.customer !== "all") {
    return { type: "customer", value: filters.customer };
  }
  return { type: "all", value: null };
}
